import React from 'react';
import PropTypes from 'prop-types';
import TableRow from '@mui/material/TableRow';
import parse from 'html-react-parser';

import { VpPromptAnswer } from '../../';
import { StyledTableCell } from './styles';

export const VpSubmissionDetailsResponses = ({ responses, mediaLabels }) => {
  return (
    <>
      {responses.map((prompt, index) => (
        <TableRow key={`prompt-${index}`}>
          <StyledTableCell>
            {prompt?.description ? parse(prompt?.description) : prompt?.question}
          </StyledTableCell>
          <StyledTableCell>
            <VpPromptAnswer prompt={prompt} mediaLabels={mediaLabels} />
          </StyledTableCell>
        </TableRow>
      ))}
    </>
  );
};

VpSubmissionDetailsResponses.propTypes = {
  responses: PropTypes.arrayOf(
    PropTypes.shape({
      question: PropTypes.string
    })
  ),
  mediaLabels: PropTypes.shape({})
};

export default VpSubmissionDetailsResponses;



// WEBPACK FOOTER //
// ./src/vp-ui/dialogs/VpMediaSubmissionDetailsDialog/VpSubmissionDetailsResponses.jsx